import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { LinkText } from 'components/shared/LinkText';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import Link from 'next/link';
import { getPublicPath } from 'utils/paths';
import {
  StyledActions,
  StyledContainer,
  StyledContent,
  StyledImage,
  StyledSection
} from './StackOverflowDevStory.styled';

const StackOverflowDevStory: React.FC = (): JSX.Element => {
  const { t } = useI18n('stackOverflowLanding');
  return (
    <StyledSection>
      <StyledContainer>
        <StyledImage>
          <img src={getPublicPath('/images/sOLanding/apes.svg')} alt="" />
        </StyledImage>
        <StyledContent>
          <Heading2 editorial>{t('devStory.title')}</Heading2>
          <p>
            <Trans
              ns={'stackOverflowLanding'}
              i18nKey={'devStory.desc'}
              components={{
                strong: <strong />,
                manfred: <LinkText href="/" />
              }}
            ></Trans>
          </p>
          <StyledActions>
            <Link passHref href="/">
              <ButtonLink variant="primary">
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>{t('devStory.CTA')}</span>
              </ButtonLink>
            </Link>

            <Link passHref href="/profile/david">
              <ButtonLink isLink>
                <span>{t('devStory.example')}</span>
              </ButtonLink>
            </Link>
          </StyledActions>
        </StyledContent>
      </StyledContainer>
    </StyledSection>
  );
};

export default StackOverflowDevStory;
